import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useEffect, useState, type JSX } from 'react';
import { SPACING_BETWEEN_FORM_FIELDS } from '../common/spacings';
import { dialogActions } from './Dialog';

type Props = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onEdit: (rechnungsnummer: string) => void;
  readonly rechnungsnummern: string[];
};

export function UmbuchenDialog({ open, onClose, onEdit, rechnungsnummern }: Props): JSX.Element {
  const [rechnungsnummer, setRechnungsnummer] = useState(rechnungsnummern[0]);

  useEffect(() => {
    if (rechnungsnummern.length > 0) {
      setRechnungsnummer(rechnungsnummern[0]);
    }
  }, [rechnungsnummern]);

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="umbuchen">
      <DialogTitle id="umbuchen">Zahlungseingang umbuchen</DialogTitle>
      <DialogContent>
        <DialogContentText>Wählen Sie eine Rechnungsnummer aus, auf die der Zahlungeingang umgebucht werden soll</DialogContentText>
        <Grid container spacing={SPACING_BETWEEN_FORM_FIELDS}>
          <Grid size={12}>
            <FormControl variant="standard" fullWidth>
              <InputLabel>Rechnungsnummer</InputLabel>
              <Select
                variant="standard"
                label="Rechnungsnummmer"
                value={rechnungsnummer ?? rechnungsnummern[0]}
                onChange={(event) => {
                  setRechnungsnummer(event.target.value);
                }}
                data-testid="rechnungsnummer-auswahl"
              >
                {rechnungsnummern.map((k) => (
                  <MenuItem key={k} value={k} data-testid={k}>
                    {k}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogActions}>
        <Button autoFocus onClick={onClose} variant="contained" color="secondary">
          Abbrechen
        </Button>
        <Button onClick={() => onEdit(rechnungsnummer)} variant="contained" color="primary">
          Umbuchen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
